export const gaming_meta = [
  { char: '🎮', name: 'Video Game', nameZh: '遊戲手把', keywords: ['play', 'game', '娛樂'] },
  { char: '🕹️', name: 'Joystick', nameZh: '搖桿', keywords: ['retro', 'game', '經典'] },
  { char: '🥽', name: 'Goggles', nameZh: 'VR/AR', keywords: ['tech', 'metaverse', '科技', '虛擬'] },
  { char: '👾', name: 'Alien Monster', nameZh: '像素怪物', keywords: ['retro', 'game', '怪獸'] },
  { char: '🤖', name: 'Robot', nameZh: 'AI機器人', keywords: ['ai', 'tech', '未來'] },
  { char: '👽', name: 'Alien', nameZh: '外星人', keywords: ['space', 'mystery', '未知'] },
  { char: '🛸', name: 'UFO', nameZh: '幽浮', keywords: ['space', 'mystery'] },
  { char: '🚀', name: 'Rocket', nameZh: '火箭/發射', keywords: ['launch', 'startup', '衝刺'] },
  { char: '🛰️', name: 'Satellite', nameZh: '衛星', keywords: ['signal', 'global', '連結'] },
  { char: '💎', name: 'Gem', nameZh: '寶石/虛寶', keywords: ['rich', 'loot', '獎勵'] },
  { char: '🪙', name: 'Coin', nameZh: '代幣', keywords: ['crypto', 'money', '點數'] },
  { char: '⛓️', name: 'Chains', nameZh: '區塊鏈', keywords: ['blockchain', 'web3', '連結'] },
];